const LinkTo = {
    shop: () => "/shop",
    order: () => "/order",
};

export default LinkTo;
